import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { BASE_URL } from "@/config/api";
import { getUserId } from "@/utils/token_functions";

const getSocketOriginUrl = () => {
  if (!BASE_URL) return null;
  try {
    const url = new URL(BASE_URL);
    return url.origin;
  } catch {
    return null;
  }
};

const SOCKET_IO_PATH = import.meta.env.VITE_SOCKET_IO_PATH || "/";

const useNotificationsSocket = (onNotification) => {
  const socketRef = useRef(null);

  useEffect(() => {
    const userId = getUserId();
    if (!userId) return;

    const originUrl = getSocketOriginUrl();
    if (!originUrl) return;

    if (socketRef.current) return;

    const socket = io(originUrl, {
      path: SOCKET_IO_PATH,
      query: { userId },
      transports: ["websocket"],
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("Notifications socket connected");
    });

    socket.on("notification", (data) => {
      if (onNotification) onNotification(data);
      else console.log("Notification event received:", data);
    });

    socket.on("disconnect", (reason) => {
      console.log("Notifications socket disconnected:", reason);
    });

    socket.on("connect_error", (error) => {
      console.error("Notifications socket connection error:", error);
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [onNotification]);
};

export default useNotificationsSocket;

